<template>
  <td class="content-type-cell">
    {{ title }}
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  created() {
    this.$glossary.ensure();
  },
  computed: {
    glossary() {
      return this.$glossary.hash;
    },
    match() {
      return this.glossary ? this.glossary[this.value] : null;
    },
    title() {
      return this.match?.title || this.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.content-type-cell {
  white-space: nowrap;
}
</style>
